// ============================================================
// Environment config. Each environment sets WS_BASE_URL and
// DOMAIN_NAME together so they can never end up mismatched
// (e.g. the prod API paired with the test dashboard domain).
//
// You normally do not need to touch this file:
//   npm start          -> local   (dev server, local backend)
//   npm run build      -> prod    (what gets deployed)
//   npm run start:test -> test    (dev server, test backend)
//   npm run build:test -> test    (test build)
//
// To force one explicitly, set REACT_APP_ENV=local|test|prod.
// ============================================================

const environments = {
    local: {
        WS_BASE_URL: 'http://localhost:2345/',
        DOMAIN_NAME: 'http://localhost:3000',
    },
    test: {
        WS_BASE_URL: 'https://tapi.getdoobi.app/',
        DOMAIN_NAME: 'https://tdashboard.getdoobi.app',
    },
    prod: {
        WS_BASE_URL: 'https://api.getdoobi.app/',
        DOMAIN_NAME: 'https://dashboard.getdoobi.app',
    },
};

// A production build defaults to prod so deploys need no edit; anything else
// (the dev server) defaults to local so it can never silently hit production.
const ENV =
    process.env.REACT_APP_ENV ||
    (process.env.NODE_ENV === 'production' ? 'prod' : 'local');

if (!environments[ENV]) {
    throw new Error(
        `Unknown REACT_APP_ENV "${ENV}". Expected one of: ${Object.keys(environments).join(', ')}`
    );
}

const config = {
    ...environments[ENV],
    ENV,
    DEMO: true,
};

export default config;
